export const getDayNames = (
  locale = 'en',
  format: 'long' | 'short' | 'narrow' | undefined = 'long'
) => {
  const dateFormat = {
    weekday: format,
    timeZone: 'UTC',
  }

  let formatter: Intl.DateTimeFormat | null = null

  try {
    formatter = new Intl.DateTimeFormat(locale, dateFormat)
  } catch (e) {
    //
  }

  if (!formatter) {
    try {
      formatter = new Intl.DateTimeFormat('en', dateFormat)
    } catch (e) {
      console.error(e)
    }
  }
  // 7 week dats map
  return [1, 2, 3, 4, 5, 6, 7]
    .map((day) => {
      return new Date(`2017-01-${day < 10 ? `0${day}` : day}T00:00:00+00:00`)
    })
    .map((date) => (formatter ? formatter.format(date) : date.toDateString()))
}
